<template lang="pug">
  v-container.fill-height.align-start.flex-column(fluid)
    v-snackbar(v-model="showSnackBar" :color="snackBarColor") {{ snackBarMessage }}
      template(v-slot:action="{ attrs }")
        v-btn.justify-end(fab text v-bind="attrs" @click="showSnackBar = false")
          v-icon fal fa-times-circle

    SmartLinkDetailDialog(
      v-if="showDetailSmartLinkDialog"
      :show="showDetailSmartLinkDialog"
      :selectedSmartLink="selectedSmartLink"
      :customers="customers"
      :boarderGroupList="boarderGroupList"
      :actionKindList="actionKindList"
      @saved="closeDialog"
      @saveError="onShowError"
      @close="onCloseDetailSmartLinkDialogClick"
      @deleted="deletedSmartLink"
      @deleteError="deleteErrorSmartLink")
    SmartLinkSearchDialog(
      v-if="showSearchSmartLinkDialog"
      :show="showSearchSmartLinkDialog"
      :smartLinks="smartLinks"
      :filterIsActive="filterIsActive"
      @showDetail="showFilteredSmartLink"
      @close="onCloseSearchSmartLinkDialogClick"
      @removeFilter="onCloseRemoveFilterSearchSmartLinkDialogClick"
    )
    v-container(style="padding: 12px 0")
      v-card.pa-0.elevation-0(v-if="!fetchInProgress")
        v-card-title.pa-0 {{ $t('smartLinkPage.smartLinkTitle') }}
        v-card-text.pa-0
          v-toolbar.elevation-0.ma-0.pa-0(v-if="$vuetify.breakpoint.mdAndUp")
            v-row.ma-0
              v-col.text-end.pa-0(cols="12")
                v-btn.mr-4(@click="onSearchSmartLinkClick" :color="getButtonColor" :disabled="getFilteredSmartLinkData && getFilteredSmartLinkData.length < 1 && !filterIsActive")
                  v-icon( color="black") fas fa-search
                  span.pl-2 {{ $t('smartLinkPage.searchButtonTitle') }}
                v-btn(@click="onAddNewSmartLinkClick" color="primary" dark )
                  v-icon() fas fa-plus
                  span.pl-2 {{ $t('smartLinkPage.addNewSmartLinkButtonTitle') }}
          v-list.ma-0(v-if="getFilteredSmartLinkData && getFilteredSmartLinkData.length > 0")
            v-list-item.ma-0.pa-0.listItem(v-for="(item,idx) in getFilteredSmartLinkData " :key="idx"  @click="onDetailSmartLinkClick(item)")
              v-list-item-icon
                v-icon(:color="getIconColor(item)" medium) {{getIcon(item)}}
              v-list-item-title {{item.slug}}
                v-list-item-subtitle.text-wrap() {{getName(item.requestKinds[0].name)}}
              v-list-item-icon
                v-icon(medium :color="getIconColor(item)") fas fa-chevron-right
          v-card.elevation-0.text-center(v-else align="center" justify="center")
            v-card-text.title.text-center( align="center" justify="center") Žiadne Smart Linky


        v-fab-transition(v-if="$vuetify.breakpoint.smAndDown")
          v-btn.searchMobileGroupButton(@click="onSearchSmartLinkClick" right bottom fixed fab dark small :color="getButtonColor" :class="getPulse" )
            v-icon(small color="black") fas fa-search
        v-fab-transition(v-if="$vuetify.breakpoint.smAndDown")
          v-btn.addMobileGroupButton(@click="onAddNewSmartLinkClick" color="primary" right bottom fixed fab dark medium)
            v-icon(medium) fas fa-plus
      v-skeleton-loader(v-else type="list-item@10")


</template>

<script lang="ts">
import {Component, Watch} from "vue-property-decorator";
import Vue from "vue";
import {Action} from "vuex-class";
import {
  BOARDER_FETCH_BOARDER_GROUP_LIST,
  CUSTOMER_FETCH_CUSTOMER_LIST, FETCH_ACTION_KIND_LIST,
  FETCH_REQUEST_KIND_LIST,
  FETCH_SMARTLINKS
} from "@/store/action-types";
import SmartLink from "@/model/SmartLink";
import SmartLinkDetailDialog from "@/components/SmartLinkDetailDialog.vue";
import Customer from "@/model/customer/Customer";
import BoarderGroup from "@/model/boarder/BoarderGroup";
import SmartLinkSearchDialog from "@/components/SmartLinkSearchDialog.vue";
import moment from "moment";
import {AxiosError} from "axios";
import RequestKindList from "@/model/RequestKindList";

@Component({
  components: {
    SmartLinkDetailDialog,
    SmartLinkSearchDialog
  }
})

export default class SmartLinksPage extends Vue {

  @Action(FETCH_SMARTLINKS) fetchSmartLinks!: { (): Promise<SmartLink[]> }
  @Action(CUSTOMER_FETCH_CUSTOMER_LIST) fetchCustomersData!: { (): Promise<Customer[]> }
  @Action(BOARDER_FETCH_BOARDER_GROUP_LIST) fetchBoarderGroupList!: { (): Promise<BoarderGroup[]> }

  @Action(FETCH_ACTION_KIND_LIST) fetchSmartLinkActionKindList!: { (): Promise<any[]> }

  private showSnackBar: boolean = false
  private snackBarColor: string = ''
  private snackBarMessage: string = ''
  private fetchInProgress: boolean = false
  private smartLinks: SmartLink[] = []
  private selectedSmartLink: SmartLink | null = null
  private showDetailSmartLinkDialog: boolean = false
  private customers: Customer []= []
  private boarderGroupList: BoarderGroup[] = []

  private showSearchSmartLinkDialog: boolean = false
  private actionKindList: any[] = []
  private foundData: SmartLink[] = []
  private filterIsActive: boolean = false

  getName (item: string) {
    if(item && item === 'onboarding') {
      return 'Prihlásenie na stravu'
    }
  }

  onDetailSmartLinkClick (item: SmartLink): void {
    this.selectedSmartLink = item
    this.showDetailSmartLinkDialog = true
  }

  getIconColor(item: SmartLink): string {
    if(item && item.activeUntil === 'infinity'|| moment(item.activeUntil).isAfter(moment())) {
      return 'success'
    } else {
      return 'grey '
    }

  }

  getIcon (item: SmartLink): string {
    if(item && item.activeUntil === 'infinity' || moment(item.activeUntil).isAfter(moment())) {
      return 'fas fa-check-circle'
    } else {
      return 'fas fa-times-circle'
    }
  }

  get getButtonColor () {
    if(this.filterIsActive) {
      return 'orange'
    } else {
      return 'grey lighten-4'
    }
  }

  get getPulse () {
    if(this.foundData && this.foundData.length > 0) {
      return "pulse-button"
    } else {
      return ''
    }
  }

  get getFilteredSmartLinkData () {
    if(this.foundData && this.foundData.length > 0) {
      return this.foundData
    } else {
      return this.smartLinks
    }
  }

  showFilteredSmartLink (item: SmartLink[]) {
    this.showSearchSmartLinkDialog = false
    this.foundData = item
    if(this.foundData) {
      this.filterIsActive = true
    } else {
      this.filterIsActive = false
    }
    return this.foundData
  }

  closeDialog (): void {
    this.showSnackBar = true
    this.snackBarColor = 'success'
    this.snackBarMessage = this.$t('sendEmailDialog.saved').toString()
    this.showDetailSmartLinkDialog = false
    this.selectedSmartLink = null
    this.fetchSmartLinksData()
  }

  deletedSmartLink(item: SmartLink): void {
    let deletedData: any | null = null
    this.showSnackBar = true
    this.snackBarColor = 'success'
    this.snackBarMessage = this.$t('smartLinkPage.deleted').toString()
    this.showDetailSmartLinkDialog = false
    this.selectedSmartLink = null
    if(this.filterIsActive && this.foundData){
      deletedData = this.foundData.find((i: any) => item.id === i.id)
      this.foundData.splice(deletedData,1)
    } else {
      this.fetchSmartLinksData()
    }
  }

  deleteErrorSmartLink(): void {
    this.showSnackBar = true
    this.snackBarColor = 'error'
    this.snackBarMessage = this.$t('smartLinkPage.deleteErrorMessage').toString()
  }

  onShowError(e: AxiosError): void {
    this.showSnackBar = true
    this.snackBarColor = 'error'
    this.snackBarMessage = this.$t('smartLinkPage.smartLinkNotSaved').toString()
  }

  onAddNewSmartLinkClick (): void {
    this.showDetailSmartLinkDialog = true
  }

  onSearchSmartLinkClick(): void {
    this.showSearchSmartLinkDialog = true
  }

  onCloseSearchSmartLinkDialogClick(): void {
    this.showSearchSmartLinkDialog = false
    this.selectedSmartLink = null
  }

  onCloseRemoveFilterSearchSmartLinkDialogClick(): void {
    this.filterIsActive = false
    this.showSearchSmartLinkDialog = false
    this.foundData = []
    this.fetchSmartLinksData()
  }

  onCloseDetailSmartLinkDialogClick(): void {
    this.showDetailSmartLinkDialog = false
    this.foundData = []
    this.selectedSmartLink = null
    //this.fetchSmartLinksData()

  }

  async fetchSmartLinksData(): Promise<void> {
    this.fetchInProgress = true
    try {
      this.smartLinks = await this.fetchSmartLinks()
    } catch (e) {
        this.showSnackBar = true
        this.snackBarColor = 'error'
        this.snackBarMessage = this.$t('businessPage.fetchDataError').toString()
    } finally {
      this.fetchInProgress = false
    }
  }

  async fetchCustomers(): Promise<void> {
    this.fetchInProgress = true
    try {
      this.customers = await this.fetchCustomersData()
    } catch (e) {
      this.showSnackBar = true
      this.snackBarColor = 'error'
      this.snackBarMessage = this.$t('businessPage.fetchDataError').toString()

    } finally {
      this.fetchInProgress = false
    }
  }

  async fetchBoarderGroup(): Promise<void> {
    this.fetchInProgress = true
    try {
      this.boarderGroupList = await this.fetchBoarderGroupList()
    } catch (e) {
      this.showSnackBar = true
      this.snackBarColor = 'error'
      this.snackBarMessage = this.$t('businessPage.fetchDataError').toString()

    } finally {
      this.fetchInProgress = false
    }
  }



  async fetchSmartLinkActionList(): Promise<void> {
    this.fetchInProgress = true
    try {
      this.actionKindList = await this.fetchSmartLinkActionKindList()
    } catch (e) {
      this.showSnackBar = true
      this.snackBarColor = 'error'
      this.snackBarMessage = this.$t('businessPage.fetchDataError').toString()

    } finally {
      this.fetchInProgress = false
    }
  }

  mounted(): void {
    this.fetchSmartLinksData()
    this.fetchCustomers()
    this.fetchBoarderGroup()
    //this.fetchRequestList()
    this.fetchSmartLinkActionList()
  }
}
</script>

<style lang="stylus" scoped>
.searchMobileGroupButton {
  bottom: 60px;
  margin-bottom: 80px
  margin-right: 25px
}

.addMobileGroupButton {
  bottom: 60px;
  margin-right: 18px
}

.pulse-button {
  border: none;
  border-radius: 90%;
  background: #d4855a;
  cursor: pointer;
  box-shadow: 0 0 0 0 rgba(#d4855a, .5);
  transform: scale(1);
  animation: pulse 1s infinite;
}

.pulse-button:hover {
  animation: pulse
}

@keyframes pulse {
    0% {
    @include transform(scale(.9));
    }
    70% {
    @include transform(scale(1));
    box-shadow: 0 0 0 15px rgba(#5a99d4, 0);
    }
    100% {
    @include transform(scale(.9));
    box-shadow: 0 0 0 0 rgba(#5a99d4, 0);
    }
}

.listItem {
  cursor pointer
}


</style>